import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { PopoverContent } from 'ui/popover';
import { NumberInput, SemanticUI } from '@iterable/deprecated_react_components';

export const MenuHeader = styled(SemanticUI.Menu.Header)`
  &&& {
    box-sizing: border-box;
    font-weight: 600;
    padding-left: ${pxToRem(10)};
    width: 100%;
    &:first-child {
      padding-top: ${pxToRem(10)};
    }
  }
`;

export const GradientContainer = styled.div`
  display: inline-flex;
  > div {
    height: ${pxToRem(20)};
    width: ${pxToRem(20)};
  }
`;

export const SelectedIconContainer = styled.div`
  background: #222;
  border-radius: 100%;
  border: ${pxToRem(2)} solid #fff;
  font-size: ${pxToRem(10)};
  height: ${pxToRem(20)};
  position: absolute;
  right: ${pxToRem(5)};
  top: ${pxToRem(5)};
  width: ${pxToRem(20)};
  .icon {
    height: ${pxToRem(15)};
    width: ${pxToRem(15)};
    padding: ${pxToRem(3)};
    color: #fff;
  }
`;

export const MenuItem = styled(SemanticUI.Menu.Item)`
  &&& .item {
    width: ${pxToRem(132)};
    &:before {
      content: unset;
      background: none;
      width: 0;
    }
  }
`;

export const FooterBar = styled(SemanticUI.Menu.Header)`
  &&& {
    border-top: ${pxToRem(1)} solid #d6d6d6;
    padding: ${pxToRem(10)};
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`;

export const NumberRangeThemeContainer = styled.div`
  vertical-align: top;
  width: calc(100% - ${pxToRem(20)});
`;

export const StyledCoreNumberInput = styled(NumberInput)`
  &&& {
    flex: 1 1 auto;
    > input[type='text'] {
      max-width: ${pxToRem(140)};
    }
  }
`;

export const MinMaxContainer = styled.div`
  display: flex;
  margin-top: ${pxToRem(10)};
  padding-left: ${pxToRem(5)};
  > div {
    flex: 1 1 auto;
    width: 50%;
  }
  label {
    font-weight: 600;
  }
`;

export const TriggerButton = styled.div`
  align-items: center;
  background: none;
  cursor: pointer;
  display: flex;
  margin-left: ${pxToRem(5)};
  gap: ${pxToRem(5)};
  height: ${pxToRem(30)};
  vertical-align: top;
  > ${GradientContainer} > * {
    height: 30px;
    width: 30px;
  }
  .icon.dropdown {
    height: unset;
  }
`;

export const StyledPopoverContent = styled(PopoverContent)`
  z-index: 100000;
  max-width: fit-content;
  .ui.menu {
    border: none;
    box-shadow: none;
    display: flex;
    flex-wrap: wrap;
    width: calc(${pxToRem(132)} * 4);
  }
`;
